import { render, staticRenderFns } from "./SliceSmallAction.vue?vue&type=template&id=225cc380&scoped=true"
import script from "./SliceSmallAction.vue?vue&type=script&lang=js"
export * from "./SliceSmallAction.vue?vue&type=script&lang=js"
import style0 from "./SliceSmallAction.vue?vue&type=style&index=0&id=225cc380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cc380",
  null
  
)

export default component.exports